import styled from "styled-components";
import APIService from "../../services/APIService";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Success from "../../components/toast/Success";
import { toast } from "react-toastify";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: var(--bg-200);
`;

const Wrapper = styled.div`
  margin: var(--spacing-xxl) 0;
  width: 94%;
  box-sizing: border-box;
  border-radius: 20px;
  padding: var(--spacing-xxl) var(--spacing-lg);
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: var(--spacing-xl);

  background: linear-gradient(135deg, var(--primary-100) 0%, var(--primary-200) 100%);
  box-shadow: var(--shadow-large);

  box-sizing: border-box;
  @media (min-width: 765px) {
    width: 100%;
    max-width: var(--max-width-container);
    padding: var(--spacing-xxl);
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;
const LeftContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  text-align: center;

  @media (min-width: 765px) {
    width: 55%;
    max-width: 55%;
    text-align: left;
  }
`;
const StarIcon = styled.svg`
  flex-shrink: 0;
`;
const Title = styled.h3`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  width: 100%;
  margin: 0;
  font-weight: 800;
  line-height: 1.15;
  font-size: var(--font-size-xlarge);
  color: var(--bg-100);
  @media (min-width: 765px) {
    justify-content: flex-start;
    font-size: 2.2rem;
  }
`;
const Text = styled.p`
  margin: 0;
  font-size: var(--font-size-base);
  max-width: 100%;
  line-height: 1.5;
  color: var(--bg-100);
  opacity: 0.9;

  @media (min-width: 765px) {
    max-width: 90%;
  }
`;

const InputContainer = styled.form`
  position: relative;
  width: 100%;
  max-width: 420px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  background-color: var(--bg-100);
  border-radius: 999px;
  padding: 6px 6px 6px var(--spacing-md);
  box-shadow: var(--shadow-medium);

  @media (min-width: 768px) {
    width: 420px;
  }
`;
const MailIcon = styled.svg`
  flex-shrink: 0;
`;
const Input = styled.input`
  flex: 1;
  min-width: 0;
  font-size: var(--font-size-base);
  font-weight: 400;
  height: 44px;
  padding: 0 var(--spacing-xs);
  border: none;
  background-color: transparent;
  color: var(--text-100);
  &::placeholder {
    color: var(--text-200);
    font-weight: 400;
  }
  &:focus {
    outline: none;
  }
`;
const Button = styled.button`
  flex-shrink: 0;
  font-size: var(--font-size-small);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  height: 44px;
  padding: 0 var(--spacing-lg);
  border-radius: 999px;
  background-color: var(--text-100);
  color: var(--bg-100);
  transition: opacity 0.2s ease;
  &:hover {
    opacity: 0.85;
  }
`;

const showSuccessNotification = (text) => {
  toast(<Success text={text} />, {
    position: "top-left",
    autoClose: 5000, // Obaveštenje će se automatski skloniti nakon 5 sekundi
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className: "custom-toast-success",
    progressClassName: "custom-progress-bar",
  });
};

const Subscription = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  //const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateEmail(email)) {
      return;
    }
    try {
      const response = await APIService.subscribe(email);
      showSuccessNotification(t("NOTIFICATIONS.SUCCESS"));
      setEmail("");
    } catch (error) {
      if (error.response) {
      }
    }
  };

  const validateEmail = (email) => {
    const trimmedEmail = email.trim();
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(trimmedEmail).toLowerCase());
  };
  return (
    <Container>
      <Wrapper>
        <LeftContainer>
          <Title>
            <StarIcon width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 2L14.39 8.26L21 9.27L16.5 13.97L17.77 20.52L12 17.27L6.23 20.52L7.5 13.97L3 9.27L9.61 8.26L12 2Z"
                fill="var(--bg-100)"
              />
            </StarIcon>
            {t("SUBSCRIPTION.TITLE")}
          </Title>
          <Text>{t("SUBSCRIPTION.DESCRIPTION")}</Text>
        </LeftContainer>
        <InputContainer onSubmit={handleSubmit}>
          <MailIcon width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3 6.5C3 5.67157 3.67157 5 4.5 5H19.5C20.3284 5 21 5.67157 21 6.5V17.5C21 18.3284 20.3284 19 19.5 19H4.5C3.67157 19 3 18.3284 3 17.5V6.5Z"
              stroke="var(--text-200)"
              strokeWidth="1.5"
            />
            <path
              d="M4 6.5L12 12.5L20 6.5"
              stroke="var(--text-200)"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </MailIcon>
          <Input
            type="email"
            placeholder={t("PLACEHOLDERS.EMAIL")}
            aria-label="Subscription"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button type="submit">{t("BUTTONS.SUBMIT")}</Button>
        </InputContainer>
      </Wrapper>
    </Container>
  );
};

export default Subscription;
